import { CONFIG } from '@mpt-fo/common/shared/config/config';
import {Component, OnInit} from '@angular/core';
import {DeviceRegistrationRequest} from'@mpt-fo/common/core/models/login.model';
import { DelegateType } from '@mpt-fo/common/shared/models/utility.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BiometricType, MobileWebViewService} from '@mpt-fo/common/core/services/mobile-web-view.service';
import {AuthenticationService} from '@mpt-fo/common/core/services/authentication.service';
import {LocalStorageService} from '@mpt-fo/common/core/services/local-storage.service';
import {OperationModeService} from '@mpt-fo/common/core/services/operation-mode.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppConfig} from '@mpt-fo/common/shared/config/app-config';
import {ComplianceService} from '@mpt-fo/common/core/services/compliance.service';
import {ModalOptionsConfig, ModalService} from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import {MobileWebViewHelperService} from '@mpt-fo/common/core/services/mobile-web-view-helper.service';
import {MobileDelegateService} from '@mpt-fo/common/core/services/mobile-delegate.service';
import {LoginHelperService} from '@mpt-fo/common/core/services/login-helper.service';
import {KycService} from '@mpt-fo/common/core/services/kyc-service';
import {DeviceHelperService} from '@mpt-fo/common/core/services/device-helper.service';
import {LoginRequestModel} from '@mpt-fo/common/shared/models/login.model';
import {ErrorModalComponent} from './components/mobile-modals/error-modal/error-modal.component';
import {StringHelper} from '@mpt-fo/common/core/helpers/strings.helper';
import {
	DeviceRegistrationModalComponent
} from './components/mobile-modals/device-registration-modal/device-registration-modal.component';
import {
	DEFAULT_DIALOG_CLASSES,
	DEFAULT_FAILED_OTP_MODAL_WIDTH,
	DEFAULT_MODAL_KAMONA_CLASSES,
	DEFAULT_MODAL_WIDTH,
	MONIEPOINT_DESIGN_TYPE,
} from '@mpt-fo/common/shared/constants';
import {AuthorizedUser} from '@mpt-fo/common/core/services/authorized-user.service';
import {DataLayerService} from '@mpt-fo/common/core/services/data-layer-service.service';
import {ScreenManagerService} from '@mpt-fo/common/core/services/screen-manager.service';
import {initializeDatalayer, updateDatalayerIdentifyUser} from '@mpt-fo/common/shared/models/data.layer.model';
import {StorageKeys} from '@mpt-fo/common/shared/models/storage-keys';
import {ErrorCode} from '@app/channels/onboarding/onboarding-v2/model/onboarding-v2-model';

@Component({
	selector: 'app-mobile-login',
	templateUrl: './mobile-login.component.html',
	styleUrls: ['./mobile-login.component.scss'],
})
export class MobileLoginComponent implements OnInit {
	validateForm!: FormGroup;
	savedUsername: string;
	readonly LOGIN = 'LOGIN';
	passwordVisible = false;
	submitting: boolean;
	hasSetupBiometric: boolean;
	biometricType: BiometricType;
	otpResponse: any;
	identifier: any;
	tokenData: any;
	ussdCode: any;
	businesses: any[] = [];
	userRole: string;
	modalCallback: any;
	modalData: any;
	runningModal: any;
	maskedSavedName: string;
	initializing = true;
	// tslint:disable-next-line:variable-name
	readonly biometric_error = 'For Security reasons your fingerprint was disabled. Login with password and change the fingerprint key';
	// tslint:disable-next-line:variable-name
	readonly biometric_error_key_wordII = 'fingerprint was disabled';
	// tslint:disable-next-line:variable-name
	readonly biometric_error_key_wordIII = 'change the fingerprint key';
	// tslint:disable-next-line:variable-name
	readonly biometric_error_key_wordI = 'For Security reasons';
	resetBiometric: boolean;
	showBiometricButton: boolean;
	currentView: string;
	allowSignup: boolean;
	readonly MOBILE_ROUTE = '/login/mobile';
	readonly SPLASH_MOBILE_ROUTE = '/login/mobile/splash-screen';
	readonly WEB_ROUTE = '/login/web';
	isInitiated = false;
	savedUser: string;
	formUserName: string;
	formPassword: string;
	showUssd: boolean;
	readonly NETWORK_ERROR = 'Please make sure you have internet connectivity';
	webBicon;

	constructor(
		private mobileService: MobileWebViewService,
		private fb: FormBuilder,
		public user: AuthorizedUser,
		private authService: AuthenticationService,
		private localStorage: LocalStorageService,
		private operationService: OperationModeService,
		private router: Router,
		public config: AppConfig,
		private complianceService: ComplianceService,
		private activatedRoute: ActivatedRoute,
		private modalService: ModalService,
		private mobileWebViewHelperService: MobileWebViewHelperService,
		private delegateService: MobileDelegateService,
		private loginHelper: LoginHelperService,
		private kycService: KycService,
		private deviceHelper: DeviceHelperService,
		public dataLayerHelper: DataLayerService,
		public screenManager: ScreenManagerService
	) {
	}

	ngOnInit(): void {
		this.setCurrentView(this.LOGIN);
		this.initialize().catch(error => {console.log(error)});
		this.screenManager.isMobile$.subscribe((isMobile) => {
			this.handleScreenMangerSubscription(isMobile);
		});
	}

	handleScreenMangerSubscription(isMobile){
		const isContainLogin = this.router?.url.includes(this.MOBILE_ROUTE) || this.router?.url.includes(this.SPLASH_MOBILE_ROUTE);
		const canRoute = isContainLogin && !isMobile;
		if (canRoute) {
			this.router.navigateByUrl('/login/web');
		}
	}

	launchModal(params, component) {
		const config = this.createModalConfig(params);
		this.runningModal = this.modalService.createModal(component, config);
	}

	checkBiometricErrorMatch(error: string) {
		if (error === this.biometric_error.toLowerCase()) {
			return true;
		}
		let matchCount = 0;
		matchCount = error.includes(this.biometric_error_key_wordI.toLowerCase()) ? ++matchCount : matchCount;
		matchCount = error.includes(this.biometric_error_key_wordII.toLowerCase()) ? ++matchCount : matchCount;
		matchCount = error.includes(this.biometric_error_key_wordIII.toLowerCase()) ? ++matchCount : matchCount;
		return matchCount > 1;
	}

	setCurrentView(view) {
		this.currentView = view;
	}

	callDialer(code: string) {
		this.delegateService
			.setDelegateData(DelegateType.launchDialer, code)
			.then((res) => {
			})
			.catch((error) => {
				window.open(`tel:${code}`, '_system');
			});
	}

	createModalConfig(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.data = params;
		config.className = 'moniepoint-dialog';
		config.nzComponentParams.callback = (result) => {
			this.handleOncloseModal(result);
		};
		return config;
	}

	handleOncloseModal(params) {
		if (this.runningModal) {
			this.runningModal.destroy();
		}
	}

	 buildLoginRequestWithBiometric(params) {
		let request: LoginRequestModel = this.validateForm.value;
		request.password = params?.biometricKey;
		request.username = params?.username;
		request.loginType = 'BIOMETRIC';
		request = this.deviceInformationRequest(request);
		return request;
	}

	 deviceInformationRequest(request) {
		const deviceInformation = this.getDeviceInformation();
		request.deviceUniqueIdentifier = deviceInformation?.deviceUniqueIdentifier;
		request.manufacturer = deviceInformation?.manufacturer;
		request.model = deviceInformation?.model;
		return request;
	}

	getDeviceInformation(){
		return this.deviceHelper.getDeviceInformation();
	}

	logSignInInitiatedEvent(savedUsername){
		const payload = this.getDataLayer('sign_in_initiated', savedUsername, '', 'biometric');
		this.dataLayerHelper.logEvent(payload);
	}
	isBiometricPage: boolean;
	async authenticateWithBiometric(isBiometricPage = false) {
		this.isBiometricPage = isBiometricPage;
		const request: LoginRequestModel = this.validateForm.value;
		const loginParameters = this.mobileService.getMoniepointAppParameters();
		const savedUsername = loginParameters?.deviceRegistrationRequest?.username || '';
		this.logSignInInitiatedEvent(savedUsername);
		!request?.username ? this.handleUserNameNotFound() : await this.handleLoginWithUserNameFound(request, savedUsername);
	}

	handleIsBiometricPage(){
		if(this.isBiometricPage){
			this.setCurrentView('LOADING');
		}
	}

	handleUserNameNotFound(){
		this.launchAlertModal({
			title: 'Invalid Credentials',
			description: 'Username is required',
		});
	}

	async handleLoginWithUserNameFound(request: LoginRequestModel, savedUsername){
		const isBiometricUser = !request?.username ? true : this.isBiometricUser(request?.username);
		isBiometricUser ? await this.handleBiometricLogin(savedUsername)
		: this.handleMismatchBiometric(savedUsername);
	}

	async handleBiometricLogin(savedUsername){
		const params = await this.buildPayloadForBiometricLogin();
		this.loginWithBiometric(savedUsername, params)
			.catch(err => {
				this.handleLoginFailedRequestViaBiometric(err, params, savedUsername);
			});
	}

	async buildPayloadForBiometricLogin(){
		const biometric = await this.getBiometricFromDelegate();
		const loginParameters = this.mobileService.getMoniepointAppParameters();
		const loginPayload = this.getMobileLoginParams(biometric, loginParameters?.deviceRegistrationRequest);
		return this.getLoginParameters(true,loginPayload);
	}

	handleLoginFailedRequestViaBiometric(err, params, savedUsername){
		this.logFailedAuthenticateWithBiometricDelegateEvent(savedUsername, err);
		const errorParameters = this.getErrorParameters(err,params, 'Biometric');
		this.handleFailedLoginRequest(errorParameters);
	}

	isBiometricUser(formUsername){
		return this.maskedSavedName === formUsername || this.savedUsername === formUsername;
	}

	logSignInFailedEvent(savedUsername, description){
		const payload = this.getDataLayer('sign_in_failed', savedUsername, description, 'biometric');
		this.dataLayerHelper.logEvent(payload);
	}

	handleMismatchBiometric(savedUsername){
		const description = 'Username and biometric don\'t match';
		this.logSignInFailedEvent(savedUsername, description);
		this.launchAlertModal({
			title: 'Invalid Credentials',
			description,
		});
	}

	async loginWithBiometric(savedUsername, params) {
		this.handleIsBiometricPage();
		this.logSuccessfulBiometricEvent(savedUsername);
		await this.login(params);
	}

	async getBiometricFromDelegate(){
		return await this.delegateService.setDelegateData(DelegateType.authenticateWithBiometric, 'Login')
	}

	handleNonForcedUserAppUpdate(params){
		const err = params?.err;
		const isUserDeviceNotRegistered = err && (err?.error?.code === '403003' || err?.error?.code === ErrorCode.LIVELINESS_REQUIRED);
		isUserDeviceNotRegistered ? this.newDeviceDetected(err, params?.request, params?.isNewUser)
		: this.handleNonRegisteredUserDevice(params);
	}

	handleNonRegisteredUserDevice(params){
		const err = params?.err;
		const description: string = err.error?.responseMessage || StringHelper.getErrorMessageHttpErrorResponse(err);
		const isUserOtpSuspended = err?.error?.code === '400209' || err?.error?.code === '400208';
		isUserOtpSuspended ? this.otpLocked(err, description) : this.handleNonSuspendedUserOtp(description, params);
		this.submitting = false;
	}

	handleNonSuspendedUserOtp(description, params){
		const errParams = {err: params?.err, username: params?.savedUsername, description, signInMode: params?.signInMode};
		this.failedLogin(description, params?.isBiometricLogin, errParams)
	}

	handleNonNetworkError(params){
		const err = params?.err;
		const isForceUpdate = err && err?.error?.code === '400000';
		const forceUserAppUpdate = isForceUpdate && this.mobileService.isMobileWebViewUser();
		forceUserAppUpdate ? this.forceAppUpdate()
		: this.handleNonForcedUserAppUpdate(params);
	}

	handleFailedLoginRequest(params){
		const isNetworkError = !window?.navigator?.onLine;
		isNetworkError ? this.handleNetworkError(params?.savedUsername, params?.signInMode)
		: this.handleNonNetworkError(params);
	}

	logSuccessfulBiometricEvent(savedUsername){
		const payload = this.getDataLayer('sign_in_success', savedUsername, '', 'biometric');
		this.dataLayerHelper.logEvent(payload);
	}

	async getMobileLoginParams(biometricKey, mobileDeviceInformation: DeviceRegistrationRequest){
		const webDeviceInformation = this.getDeviceInformation();
		const deviceInformation: any = {biometricKey, username: this.savedUsername, loginType: 'BIOMETRIC'}
		deviceInformation.deviceUniqueIdentifier = mobileDeviceInformation?.deviceUniqueIdentifier ?? webDeviceInformation?.deviceUniqueIdentifier;
		deviceInformation.model = mobileDeviceInformation?.model ?? webDeviceInformation?.model;
		deviceInformation.manufacturer = mobileDeviceInformation?.manufacturer ?? webDeviceInformation?.manufacturer
		return deviceInformation;
	}

	logFailedAuthenticateWithBiometricDelegateEvent(savedUsername, error){
		const payload = this.getDataLayer('sign_in_failed', savedUsername, error.toString(), 'biometric');
		this.dataLayerHelper.logEvent(payload);
	}

	handleError(title: string, description: string, submitButtonName: string) {
		const errorMessageParameters = {
			title,
			description,
			submitButtonName,
			showFullButton: true,
		};
		this.launchModal(errorMessageParameters, ErrorModalComponent);
	}

	buildLoginRequest() {
		let request: LoginRequestModel = this.validateForm.value;
		request.loginType = 'PASSWORD';
		request = this.deviceInformationRequest(request);
		return request;
	}

	setLoggedInUser(username) {
		this.delegateService
			.setDelegateData(DelegateType.setLoggedInUser, username)
			.then(() => {
				this.mobileService.setSavedUsername(username);
			})
			.catch((error) => {
				console.log('error from setLoggedInUser', error);
			});
	}

	listenForOtp() {
		this.delegateService
			.getDelegateData(DelegateType.listenForOtp)
			.then((res) => {
			})
			.catch((error) => {
				console.log('Error calling listenForOtp delegate ', error);
			});
	}

	getLoginParameters(isBiometricLogin, params){
		const request = isBiometricLogin ? this.buildLoginRequestWithBiometric(params) : this.buildLoginRequest();
		const savedUsername = request?.username;
		this.user.setLoginCredentials({username: request?.username, password: request?.password,});
		const isNewUser = this.isNewUser(savedUsername, request);
		return {request, savedUsername, isNewUser, isBiometricLogin};
	}

	isNewUser(savedUsername, request){
		const isMaskedUserName = savedUsername === this.maskedSavedName;
		request.username = isMaskedUserName ? this.savedUsername : savedUsername;
		const userNameForCompare = isMaskedUserName ? request.username : savedUsername;
		return  this.resetBiometric || userNameForCompare !== this.savedUsername;
	}

	async login(params) {
		this.submitting = true;
		const deviceType = params?.request?.model?.toUpperCase();
		this.updateClientTypeIfMobileApp(deviceType);
		const payload = params?.request;
		const res = await this.authService
			.WebViewLogin(payload, deviceType, false, this.mobileService.isMobileWebViewUser());
		await this.handleLoginResponse(res, params);
	}

	updateClientTypeIfMobileApp(deviceType){
		if (this.mobileService.isMobileWebViewUser()) {
			this.mobileService.setClientType(deviceType);
		}
	}

	async handleLoginResponse(res, params){
		this.handleSuccessLoginEvents(params);
		this.setPreBiometricCredentials(params?.request?.username, params?.isNewUser);
		const deviceInformation = this.getDeviceInformation();
		await this.loginHelper.processSessionUser(res, deviceInformation);
	}

	handleSuccessLoginEvents(params){
		const usernameFromApp = this.getUsernameFromApp();
		const isMaskedUserName = params?.savedUsername === this.maskedSavedName;
		const payload = this.getDataLayer('sign_in_success', isMaskedUserName ? usernameFromApp : params?.savedUsername, '', params?.signInMode, params?.res);
		const payload1 = this.getDataLayer('identify_user', isMaskedUserName ? usernameFromApp : params?.savedUsername, '', params?.signInMode, params?.res);
		this.dataLayerHelper.logEvent(payload);
		this.dataLayerHelper.logEvent(payload1);
	}

	getUsernameFromApp(){
		const loginParameters = this.mobileService.getMoniepointAppParameters();
		return loginParameters?.deviceRegistrationRequest?.username || '';
	}

	forceAppUpdate() {
		this.router
			.navigateByUrl('/login/mobile/upgrade')
			.then(() => {
				this.submitting = false;
			})
			.catch(() => {
				this.submitting = false;
			});
	}

	newDeviceDetected(err, request, isNewUser) {
		const deviceRegistrationParameters = this.buildDeviceRegistrationParams(err, request);
		this.localStorage.setSessionExpiration(this.tokenData?.exp);
		this.mobileService.setDeviceRegistrationParameters(deviceRegistrationParameters);
		this.listenForOtp();
		this.launchModal(deviceRegistrationParameters, DeviceRegistrationModalComponent);
		this.setPreBiometricCredentials(request?.username, isNewUser);
		this.submitting = false;
	}

	loginErrorEvent(params) {
		const payload = this.getDataLayer('sign_in_failed', params?.username, params?.description, params?.signInMode);
		payload[`api_error_message`] = StringHelper.getMixpanelErrorMessage(params?.err);
		payload[`api_error_code`] = params?.err?.status;
		this.dataLayerHelper.logEvent(payload);
	}

	networkErrorEvent(params) {
		const payload = this.getDataLayer('sign_in_failed', params?.username, params?.description, params?.signInMode);
		payload[`api_error_message`] = params?.description;
		payload[`api_error_code`] = '';
		this.dataLayerHelper.logEvent(payload);
	}

	handleNetworkError(username, signInMode) {
		const description = this.NETWORK_ERROR;
		this.networkErrorEvent({description, username, signInMode});
		this.launchAlertModal({title: 'No Connectivity', description});
		this.submitting = false;
	}

	failedLogin(description, isBiometricLogin, params) {
		this.loginErrorEvent(params);
		this.biometricLoginFailed(description, isBiometricLogin);
		this.launchAlertModal({
			title: 'Login Failed',
			description,
		});
	}

	otpLocked(err, description) {
		const suspensionReleaseTime = err?.error?.suspensionReleaseTime;
		this.launchFullAlertModal({
			title: 'OTP Lockout',
			description,
			expiryTime: new Date(`${suspensionReleaseTime}`).getTime(),
			callbackName: 'Retry',
		});
	}

	biometricLoginFailed(description, isBiometricLogin) {
		if (!isBiometricLogin) {
			return;
		}
		const isErrorMatches = this.checkBiometricErrorMatch(description.toLowerCase());
		this.resetUserBiometric(isErrorMatches);
		this.setCurrentView(this.biometricType);
	}

	resetUserBiometric(isErrorMatches) {
		if (!isErrorMatches) {
			return;
		}
		this.resetBiometric = true;
		this.deleteBiometricKey(this.biometricType !== BiometricType.NONE);
	}

	deleteBiometricKey(canRegister: boolean) {
		this.delegateService
			.getDelegateData(DelegateType.deleteBiometricKey)
			.then((res) => {
				this.mobileService.setRegisterBiometric(canRegister);
			})
			.catch((error) => {
				console.log('Error deleting biometry key ', error);
			});
	}

	buildDeviceRegistrationParams(err, request) {
		const deviceParams: any = {};
		this.updateDeviceRegistrationParamsWithRequestObj(deviceParams, request);
		this.updateDeviceRegistrationParamsWithErrorResponse(deviceParams, err);
		this.setDeviceRegistrationParameters(deviceParams);
		return deviceParams;
	}

	setDeviceRegistrationParameters(deviceParams){
		this.otpResponse = deviceParams?.error;
		this.identifier = deviceParams?.identifier;
		this.tokenData = deviceParams?.tokenData;
		this.ussdCode = deviceParams.ussdCode;
	}

	updateDeviceRegistrationParamsWithRequestObj(deviceParams: any, request){
		deviceParams.username = request?.username;
		deviceParams.password = request?.password;
	}

	updateDeviceRegistrationParamsWithErrorResponse(deviceParams: any, error){
		deviceParams.otpResponse = error?.error;
		deviceParams.ussdCode = error?.error?.ussdCode;
		deviceParams.identifier = error?.error?.identifier;
		deviceParams.tokenData = error?.error?.tokenData;
		deviceParams.expiryTime = error?.error?.expiryTime;
	}

	navigationHelper(url) {
		this.router.navigateByUrl(`${url}`);
	}

	async initialize() {
		this.initializeLoginConfigs();
		this.setLoginForm();
		const loginParameters = this.mobileService.getMoniepointAppParameters();
		const savedUsername = loginParameters?.deviceRegistrationRequest?.username || '';
		await this.initializeMobileAppParameters(loginParameters?.deviceRegistrationRequest, savedUsername);
		this.setBiometricParams(loginParameters?.hasSetupBiometric, loginParameters?.biometricType);
	}

	async initializeMobileAppParameters(deviceRegistrationRequest: DeviceRegistrationRequest, savedUsername){
		if (this.mobileService.isMobileWebViewUser()) {
			this.setUserName(savedUsername);
			await this.setDeviceInformation(deviceRegistrationRequest);
		}
	}

	initializeLoginConfigs(){
		this.webBicon = this.config.WEB_BICON;
		this.allowSignup = this.config.ALLOW_SIGN_UP;
		this.showUssd = this.config.SHOW_LOGIN_USSD;
	}

	setBiometricParams(hasSetupBiometric, biometricType) {
		this.mobileService.setHasSetupBiometric(hasSetupBiometric);
		this.biometricType = biometricType || BiometricType.NONE;
		this.hasSetupBiometric = hasSetupBiometric;
		this.showBiometricButton = biometricType !== 'NONE' && hasSetupBiometric;
		this.mobileService.setBiometricType(this.biometricType);
		this.setCurrentViewWithBiometricParameter(biometricType);
	}

	setCurrentViewWithBiometricParameter(biometricType){
		const isBiometricPage = this.showBiometricButton && this.savedUsername;
		isBiometricPage ? this.setCurrentView(biometricType) : this.setCurrentView(this.LOGIN);
	}


	async setDeviceInformation(parameters) {
		const deviceInformation = this.buildDeviceInformationObj(parameters);
		await this.deviceHelper.saveDeviceInformation(deviceInformation);
	}

	buildDeviceInformationObj(parameters){
		return  {
			deviceUniqueIdentifier: parameters?.deviceUniqueIdentifier,
			model: parameters?.model,
			manufacturer: parameters?.manufacturer,
			deviceType: parameters?.model?.toUpperCase(),
		};
	}

	setUserName(username) {
		this.savedUsername = username;
		this.patchLoginForm(username);
	}

	launchAlertModal(params, route = '') {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = params.alertType || 'error';
		config.nzComponentParams.title = 'Request Failed';
		this.updateModalConfigWithDefaultParams(config);
		this.handleModalAlertCallback(config, route);
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.alert(config);
	}
	handleModalAlertCallback(config: ModalOptionsConfig, route: string){
		if (route) {
			config.nzComponentParams.callback = () => {
				this.handleCloseModal(route);
			};
		}
	}

	handleCloseModal(route) {
		if (route) {
			window.open(`${route}`, '_blank');
		}
		if (this.runningModal) {
			this.runningModal.destroy();
		}
	}

	launchFullAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = params?.alertType || 'error';
		config.nzComponentParams.title = params?.title || 'Request Error';
		this.updateFullModalConfigWithDefaultParams(config);
		config.nzComponentParams.expiryTime = params?.expiryTime;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.newalert(config);
	}

	updateFullModalConfigWithDefaultParams(config: ModalOptionsConfig){
		config.className = DEFAULT_DIALOG_CLASSES;
		config.nzWidth = DEFAULT_FAILED_OTP_MODAL_WIDTH;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
	}

	updateModalConfigWithDefaultParams(config: ModalOptionsConfig){
		config.className = DEFAULT_MODAL_KAMONA_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
	}

	setLoginForm() {
		const credentials = this.user.loginCredentials;
		const username = credentials?.username || null;
		this.validateForm = this.fb.group({
			username: [username, [Validators.required]],
			password: [null, [Validators.required]],
		});
		this.handleOnchangeLoginForm();
	}

	handleOnchangeLoginForm(){
		this.validateForm?.get('username')?.valueChanges.subscribe((value) => {
			if (!this.isInitiated) {
				const username = this.validateForm?.value?.username;
				this.savedUser = this.validateForm?.value;
				const payload = this.getDataLayer('sign_in_initiated', username, '', 'username and password');
				this.dataLayerHelper.logEvent(payload);
				this.isInitiated = true;
			}
		});
	}

	patchForm($event, formName) {
		this.validateForm.patchValue({
			[formName]: $event,
		});
	}

	patchLoginForm(savedUsername) {
		this.maskedSavedName = savedUsername ? `${savedUsername.substring(0, 3)}#####` : savedUsername;
		this.formUserName = this.maskedSavedName;
		this.validateForm.patchValue({
			username: this.maskedSavedName,
		});
	}

	submitForm() {
		if (this.submitting) {
			return;
		}
		this.validateForm.invalid ? this.handleInvalidCredential()
		: this.handleValidCredential();
	}

	async handleValidCredential(){
		const params = this.getLoginParameters(false,null);
		this.login(params)
			.catch(err =>{
				const errorParameters = this.getErrorParameters(err,params, 'username and password');
				this.handleFailedLoginRequest(errorParameters);
			})
	}

	getErrorParameters(err, params, signInMode){
		return {err,savedUsername: params?.savedUsername, signInMode, isNewUser: params?.isNewUser, request: params?.request, isBiometricLogin: params?.isBiometricLogin}
	}

	handleInvalidCredential(){
		this.launchAlertModal({
			title: 'Login Failed',
			description: 'Please enter a valid credential(s)',
		});
		this.submitting = false;
	}

	goToSlashPage() {
		if (!this.savedUsername && this.mobileService.isMobileWebViewUser()) {
			this.router.navigateByUrl(`/login/mobile/splash-screen`);
		}
	}

	getDataLayer(event, username, message = '', mode = '', data = null) {
		const datalayer = initializeDatalayer(event);
		datalayer.error_message = message;
		datalayer.user_name = username;
		datalayer.sign_in_mode = mode;
		datalayer.business_owner_first_name = localStorage.getItem(StorageKeys.firstName) || '';
		this.updateDataLayerIfEventIsIdentifyUser(datalayer, event, data);
		return datalayer;
	}

	updateDataLayerIfEventIsIdentifyUser(datalayer, event, data){
		if (event === 'identify_user') {
			datalayer = updateDatalayerIdentifyUser(datalayer);
			datalayer.email = data?.tokenData?.email;
			datalayer.business_owner_first_name = data?.tokenData.firstName;
		}
	}

	signUp() {
		const route = '/onboarding/create-account';
		const canUseNewOnboardingFlow = this.config.USE_NEW_SIGN_UP_FLOW;
		canUseNewOnboardingFlow ? this.signUpToNewOnboardingFlow()
		: this.router.navigateByUrl('/onboarding/create-account');
	}

	signUpToNewOnboardingFlow(){
		this.loginHelper.initializeSignup();
		this.router.navigateByUrl('/onboarding-v2');
	}

	private setPreBiometricCredentials(username, isNewUser = false) {
		this.setLoggedInUser(username);
		const hasBiometricEnabled = this.biometricType !== BiometricType.NONE;
		const canSetBiometric = !this.hasSetupBiometric && hasBiometricEnabled;
		isNewUser ? this.deleteBiometricKey(hasBiometricEnabled)
		: this.mobileService.setRegisterBiometric(canSetBiometric);
	}
}
